import _ from "lodash";
import * as Cesium from 'cesium';
import styled from "styled-components";
import { Box, Switch } from "@mui/material";
import FormField from "components/FormField";
import TextButton from "components/TextButton";
import { FormItem } from "components/ActionModal";
import React, { useEffect, useState } from "react";
import { splitArrayIntoChunksOfLen } from "helper";
import ColorButton from "components/common/ColorButton";
import BlackSelect from "components/common/BlackSelect";
import { Colors, LabelSizes, LabelColors } from "constant";
import PercentSlider from "components/common/PercentSlider";

const Wrapper = styled(Box)`
  position: relative;
  border: 1px solid #a8a8a8;
  border-radius: 0.25rem;
`;

const Label = styled.p`
  position: absolute;
  left: 10px;
  top: -9px;
  background: #2F2F2F;
  z-index: 1;
  font-size: 1.2rem;
  padding: 0 5px;
`;

const DisplayOptions = styled.div`
  margin: 20px 0 0;
`;

const FormGroups = styled.div`
  margin-top: 25px;
  display: inline-flex;
  grid-gap: 14px;
  width: 100%;

  & > * {
    flex-basis: 50%;
  } 
`;

const LabelColor = styled.div`
  fieldset {
    padding: 10px;
    border: 1px solid #a8a8a8;
    border-radius: .25rem;

    label {
      margin: 0;
    }
  }
`;

const ShowMeasurements = styled(Box)`
  padding: 5px 10px;
  background: #232323;
  border-radius: 3px;

  h4 {
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #C4C4C4;
  }

  .MuiSwitch-switchBase {
    position: absolute !important;
  }

  .MuiSwitch-colorPrimary {
    color: #487BF2 !important;
  }

  .MuiSwitch-track {
    background-color: #707173 !important;
  }
`;

const labels = [
  { label: 'Show', value: 1 },
  { label: 'Hide', value: 2 }
];

const ColorPicker = ({ label, type, handlePickedColor, handleFeatureWidth, handlePickedOpacity, Labelsizevalue, LabelColorvalue, handleLabelVisibility }) => {
  const [opactiy, setOpacity] = useState(100);
  const [showOptions, setShowOptions] = useState(false);
  const [showMeasureMents, setShowMeasureMents] = useState(false);
  const [width, setWidth] = useState(window.actualAnnotationId && window.annotationObj[`${window.actualAnnotationId}`] ? window.annotationObj[`${window.actualAnnotationId}`].LineWidth : 3);
  const [color, setColor] = useState(window.actualAnnotationId && window.annotationObj[`${window.actualAnnotationId}`] ? window.annotationObj[`${window.actualAnnotationId}`].FillColor : Cesium.Color.fromCssColorString('#487BF2'));
  const [labelColor, setLabelColor] = useState(window.actualAnnotationId && window.annotationObj[`${window.actualAnnotationId}`] ? window.annotationObj[`${window.actualAnnotationId}`].LabelfillColor : Cesium.Color.fromCssColorString('#FFFFFF'));

  useEffect(() => {
    if (!window.annotationObj[`${window.actualAnnotationId}`]) return;
    
    if (type == 'Line') {
      setOpacity((parseFloat((window.annotationObj[`${window.actualAnnotationId}`].LineFillTransparency)) * 100).toFixed(0));
    } else {
      setOpacity((parseFloat((window.annotationObj[`${window.actualAnnotationId}`].PolygonFillTransparency)) * 100).toFixed(0));
    }
    
    setWidth(window.annotationObj[`${window.actualAnnotationId}`].LineWidth);
  }, [])
  
  useEffect(() => {
    if (type !== 'Polygon') return;
    if (opactiy === window.activeShape.PolygonFillTransparency) return;
    
    setOpacity((window.activeShape.PolygonFillTransparency * 100).toFixed(0));
  }, [type])

  useEffect(() => {
    handlePickedOpacity(opactiy, type);
  }, [opactiy])
  
  const handleClickPicker = (item) => {
    setColor(item);
    handlePickedColor(item);
  };

  const handleChangeWidth = (item) => {
    setWidth(item);
    handleFeatureWidth(item)
  };

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const handleLabel = (e) => {
    handleLabelVisibility(e.target.value)
  };

  const handleLabelSize = (e) => {
    Labelsizevalue(e.target.value);
  };

  const handleLabelColor = (value) => {
    setLabelColor(value);
    LabelColorvalue(value);
  };

  const handleShowMeasureMents = (e) => {
    setShowMeasureMents(e.target.checked)
  };

  return (
    <Wrapper p="20px" mb="2rem">
      <Label>{label}</Label>
      <Box display="flex" justifyContent="space-between" alignItems='center' height='40px'>
        <PercentSlider value={opactiy} onChange={(value) => setOpacity(value)} />
        <FormItem style={{'margin-bottom': '0px', 'height': '100%'}}>
          <BlackSelect options={_.range(1, 6).map((item) => ({ value: item, label: `${item}px` }))} value={width} onChange={(value) => handleChangeWidth(value)} tooltip="true" tooltipTitle="Line size" tooltipLabel="line-size" tooltipPlacement="right" />
        </FormItem>
      </Box>
      {splitArrayIntoChunksOfLen(Colors, 8).map((itemList, index) => (
        <Box display="flex" flexDirection="row" mt="9px" key={index}>
          {itemList.map((item, itemIndex) => (
            <Box mr="9px" key={itemIndex}>
              <ColorButton color={item} active={color === item} onClick={() => handleClickPicker(item)} />
            </Box>
          ))}
        </Box>
      ))}
      <DisplayOptions>
        <TextButton onClick={toggleOptions} text={showOptions ? "Hide Options" : "Display Options"} />
        {showOptions &&
          <>
            <FormGroups>
              <FormField label="Label" id="project_label">
                <select id="project_label" onChange={handleLabel}>
                  {labels.map(item => <option value={item.value} key={item.value}>{item.label}</option>)}
                </select>
              </FormField>
              <FormField label="Label Size" id="project_label_size">
                <select id="project_label_size" onChange={handleLabelSize}>
                  {LabelSizes.map(item => <option value={item.value} key={item.value}>{item.label}</option>)}
                </select>
              </FormField>
            </FormGroups>
            <LabelColor>
              <FormField label="Label Color" id="label_color" className="label-color">
                <Box display="flex" flexDirection="row">
                  {LabelColors.map((color, index) => (
                    <Box mr="6px" key={index}>
                      <ColorButton color={color} active={labelColor === color} onClick={() => handleLabelColor(color)} />
                    </Box>
                  ))}
                </Box>
              </FormField>
            </LabelColor>
            <ShowMeasurements display="flex" justifyContent="space-between" alignItems="center">
              <h4>Show Measurements</h4>
              <Switch checked={showMeasureMents} onChange={handleShowMeasureMents} name="show_measurements" color="primary" />
            </ShowMeasurements>
          </>}
      </DisplayOptions>
    </Wrapper>
  );
};

export default ColorPicker;